// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"64e0a622","295":"6a9c1717","331":"bae08620","476":"48cc21b8","629":"fd14743e","776":"6c1384df","787":"f027230d"}[chunkId] + ".chunk.js";
};